export default (app, history) => async context => {
  const { code } = context.error;

  if (code === 401) {
    await app.clearUser();
    history.replace('/login');
  }

  return context;
};
